<template>
    <div data-testid="step-clientZoneLogin" class="container">
        <h1
            v-if="!showSecondHeader"
            class="container__standard-header container__standard-header--modify"
        >
            {{ $t(`${TRANSLATION_KEY}.redirectToTheClientZoneHeaderOne`) }}
        </h1>
        <h1
            v-else
            class="container__standard-header container__standard-header--modify"
        >
            {{ $t(`${TRANSLATION_KEY}.redirectToTheClientZoneHeaderTwo`) }}
        </h1>
        <div class="row--log-into-client-zone">
            <img
                v-if="UtilityHelper.isOandaPath()"
                class="loader__gif"
                src="@/assets/oanda_loader.gif"
                alt=""
            />
            <div v-else class="client-zone-loader" />
        </div>
        <p>{{ $t(`${TRANSLATION_KEY}.dontRefresh`) }}</p>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, computed, watch } from 'vue';
import { UtilityHelper } from '@/helpers/UtilityHelper';
import { useStore } from 'vuex';
import { SET_PROGRESS } from '@/constants/mutation-types';
import { UrlHelper } from '@/helpers/UrlHelper';
import { PROGRESS_BAR_TIMES } from '@/constants/progress-bar-times';

export default defineComponent({
    name: 'ClientZoneLogin',
    components: {},
    setup() {
        const time = ref(17);
        const showSecondHeader = ref(false);
        const TRANSLATION_KEY = 'steps.ClientZoneLogin';
        const store = useStore();

        onMounted(() => {
            store.commit(SET_PROGRESS, PROGRESS_BAR_TIMES.CLIENT_ZONE_LOGIN);
            setTimeout(() => {
                time.value = 0;
            }, time.value * 1000);
            setTimeout(() => {
                showSecondHeader.value = true;
            }, 10000);
        });

        const isOandaPath = computed(() => UtilityHelper.isOandaPath());

        watch(time, (newValue) => {
            if (newValue === 0) {
                redirectToHub();
            }
        });

        const redirectToHub = () => {
            window.location.replace(UrlHelper.getHubUrl() + '?refresh=true');
        };

        return {
            time,
            showSecondHeader,
            TRANSLATION_KEY,
            isOandaPath,
            UtilityHelper,
        };
    },
});
</script>

<style lang="scss" scoped>
p {
    margin-top: 40px;
    font-size: 18px;
    font-weight: 700;
    text-align: center;
    line-height: 24px;
}

img {
    height: 100px;
}
</style>
